import { render, staticRenderFns } from "./SupportEnded.vue?vue&type=template&id=4b97f1f9&scoped=true"
import script from "./SupportEnded.vue?vue&type=script&lang=js"
export * from "./SupportEnded.vue?vue&type=script&lang=js"
import style0 from "./SupportEnded.vue?vue&type=style&index=0&id=4b97f1f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b97f1f9",
  null
  
)

export default component.exports